import React from 'react';
import PropTypes from 'prop-types';
import {generateRoutePath} from 'epic-common/src/route';

const TutorialGame = ({data}) => {
    const {title, id, question = []} = data;
    return (
        <div className="question-section" id={id}>
            <h3>{title}</h3>
            <div className="question-list">
                {question.length > 0 &&  
                    question.map((item, i) => {
                        return (
                            <div className="col-xs-12 col-sm-6 col-md-4 question-item" key={`${item.name}`}>
                                <a className="tile-box" href={generateRoutePath(item.url)}>
                                    <img src={item.image} className="tile-image" alt={item.name}/>
                                    <div className="tile-content">
                                        <h4>{item.name}</h4>
                                    </div>
                                </a>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

TutorialGame.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        id: PropTypes.string,
        question: PropTypes.array
    })
}

export default TutorialGame
